<template>
  <el-dialog
      :visible.sync="visible"
      :title="!dataForm.id ? $t('add') : $t('update')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-form-item label="上级工艺：" prop="parentId">
        <el-select v-model="dataForm.parentId">
          <el-option v-for="item in techList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工艺名称：" prop="name">
        <el-input v-model="dataForm.name" placeholder="工艺名"></el-input>
      </el-form-item>
      <el-form-item label="顺序号：" prop="sortNo">
        <el-input v-model="dataForm.sortNo" placeholder="顺序"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { isPositiveNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      id: '',
      visible: false,
      techList: [],
      dataForm: {
        id: '',
        name: '',
        parentId: '',
        sortNo: '',
        price: '',
      },
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
        price: [{ validator: moneyValidator, trigger: 'change' }],
        sortNo: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: function (rule, value, callback) {
              if (value && !isPositiveNumber(value)) {
                callback(new Error('请输入正确的数字'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ]
      }
    },
  },
  methods: {
    async queryTechList () {
      const { data: res } = await this.$http.get(`/trade/technology/list`, { params: { pid: 0 } })
      this.techList = res.data
    },
    reset () {
      this.dataForm = {
        name: '',
        parentId: '',
        sortNo: '',
        price: '',
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.queryTechList()
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/trade/technology/${this.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
            }
          })
          .catch(() => {
          })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              ...this.dataForm,
            }
            this.$http[!postForm.id ? 'post' : 'put'](
                '/trade/technology/',
                postForm
            )
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.cancel()
                      this.$emit('refreshDataList')
                    },
                  })
                })
                .catch(() => {
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
    cancel () {
      this.visible = false
    },
  },
}
</script>
